import React, { useState } from "react";
import Button from "components/button";
import IndexModal from "components/modal";
import { Plus } from "lucide-react";


const TicketButton = ({
    children, 
    buttonClass 
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                onClick={() => setIsOpen(true)}
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-semibold transition-all 
                            shrink-0 h-9 px-4 py-2 bg-white text-blue-600 hover:bg-blue-50 gap-2 shadow-lg ${buttonClass || ""}`}
            >
                <Plus className="w-4 h-4" />
                <span>New Ticket</span>
            </Button>

            <IndexModal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                useCustomClass={true}
                maxContentHeight="85vh"
                width="500px"
            >
                {React.cloneElement(children, { onClose: () => setIsOpen(false) })}
            </IndexModal>
        </>
    );
};

export default TicketButton;
